export const IconLink = ({ icon: Icon, href, sx, aria }) => (
  <Icon onClick={() => window.open(href)} sx={sx} aria-label={aria} />
);
